export default __webpack_public_path__ + "static/media/treehouse.48ca51ae.png";